import type { FC } from 'react'
import type { CellProps } from '../../../interfaces'

const BrCell: FC<CellProps> = ({ title }) => {
  return (
    <div className='custom-cell br-cell'>
      {title.split(',').map((name, index) => (
        <div key={`${name}-${index}`} className='sub=br'>
          {name}
        </div>
      ))}
    </div>
  )
}

export default BrCell
